import { render, staticRenderFns } from "./duplicate_button.vue?vue&type=template&id=afa8ea6c&scoped=true&lang=pug"
import script from "./duplicate_button.vue?vue&type=script&lang=js"
export * from "./duplicate_button.vue?vue&type=script&lang=js"
import style0 from "./duplicate_button.vue?vue&type=style&index=0&id=afa8ea6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa8ea6c",
  null
  
)

export default component.exports